export default "__VITE_PUBLIC_ASSET__fda34572__"